import React from "react";
import withResponsiveness from "../../../hoc/withResponsiveness";
import desktop from "./desktop";
import mobile from "./mobile";
import { OrderItemViewProps } from "./types";

const OrderItemView = withResponsiveness<OrderItemViewProps>({ mobile, default: desktop });
OrderItemView.displayName = "OrderItemView";

export default React.memo(OrderItemView);